module.exports = __webpack_public_path__ + "static/media/Inventor Fillet command.fb609974.png";